// 首页模块
import request from '@/utils/request'

// 获取公告信息
export const getSysNotice = () => {
  return request({
    method: 'get',
    url: '/home/notice'
  })
}

// 专家TOP排行
export const getMavinTop = (lotteryId, areaId, limit) => {
  return request({
    method: 'get',
    url: '/home/mavinTop',
    params: { lotteryId, areaId, limit }
  })
}

// 根据玩法属性查询的专家TOP排行
export const getMavinTopByAttribute = (areaId, days, attribute) => {
  return request({
    method: 'get',
    url: '/home/mavinTopByAttribute',
    params: { areaId, days, attribute }
  })
}

// 帖子TOP排行查询
export const getPostTop = (areaId) => {
  return request({
    method: 'get',
    url: '/home/postTop',
    params: { areaId }
  })
}

// 彩种页数据查询
export const getLotteryPage = (lotteryId) => {
  return request({
    method: 'get',
    url: '/home/lotteryPage',
    params: { lotteryId }
  })
}

// 根据彩种、区域查玩法列表
export const getPlaytypeList = (lotteryId, areaId) => {
  return request({
    method: 'get',
    url: '/home/playtypeList',
    params: { lotteryId, areaId }
  })
}

// 排行榜：专家列表页
export const getMavinList = (params) => {
  return request({
    method: 'get',
    url: '/home/mavinList',
    params: params
  })
}

// 推荐页：帖子列表页
export const getPostList = (params) => {
  return request({
    method: 'get',
    url: '/home/postList',
    params: params
  })
}